import { buildProps as e } from "./index601.js";
const r = "ElOption", t = e({
  /**
   * @description value of option
   */
  value: {
    type: [String, Number, Boolean, Object],
    required: !0
  },
  /**
   * @description label of option, same as `value` if omitted
   */
  label: {
    type: [String, Number]
  },
  created: Boolean,
  /**
   * @description whether option is disabled
   */
  disabled: Boolean
});
export {
  r as COMPONENT_NAME,
  t as optionProps
};
